const genderStatus = [
    { value: "", translate: 'ALL' },
    { value: "F", translate: 'REPORT_PATIENT_GENDER_F' },
    { value: "M", translate: 'REPORT_PATIENT_GENDER_M' },
  ];
export default genderStatus